import React, { isValidElement, useState } from "react";
import { Grid, Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { useTranslation } from "react-i18next";
import MasterDataBank from "../MasterDataBankComponent/MasterDataBank";
import MasterDataAdress from "../MasterDataAdressComponent/MasterDataAdress";
import MasterKinderComponent from "../MasterKinder/MasterKinder";
import { useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import ProfileLohnDetails from "../ProfileLohnDetails/ProfileLohnDetails";
import { useAuth } from "../../context/auth-context";
import { useEffect } from "react";
import apiRequest from "../../functions/api";
import EuroIcon from "@mui/icons-material/Euro";
import { useMessage } from "../../context/message-context";
import Personalinformation from "../Personalinformation/Personalinformation";
import MasterSonstige from "../MasterSonstige";
import MasterNotkontakt from "../MasterNotkontakt";

function MasterDataChange(props) {
  const { t } = useTranslation();
  const { accessToken, client } = props;
  const { user } = useAuth();
  const [bearbeitung, setBearbeitung] = useState(false);
  const { showErrorMessage } = useMessage();
  const [priv] = useLocalStorage(LOCAL_STORAGE_KEY.private);
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [kinderBeantragen, setKinderBeantragen] = useState(false);
  const [showKinder, setShowKinder] = useState(false);

  const [steuerDaten, setSteuerDaten] = useState([]);
  const [kinderDaten, setKinderDaten] = useState([]);
  const [bankDaten, setBankDaten] = useState([]);
  const [notkontaktDaten, setNotkontaktDaten] = useState([]);

  const [adressDaten, setAdressDaten] = useState([]);
  const [personalDaten, setPersonalDaten] = useState([]);

  const [sonstigeFelder, setSonstigeFelder] = useState([]);

  const reloadDaten = () => {
    setIsLoading(true);
    datenHolen();
  };
  useEffect(() => {
    datenHolen();
  }, []);
  const datenHolen = () => {
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "STAMMDATEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, datencb, errorCb);
  };
  const datencb = (response) => {
    setReload(false);
    if (response.status === 200) {
      if (response.data.personaldaten) {
        setPersonalDaten(response.data.personaldaten);
      }
      if (response.data.adressdaten) {
        setAdressDaten(response.data.adressdaten);
      }
      if (response.data.bankdaten) {
        setBankDaten(response.data.bankdaten);
      }
      if (response.data.kinder) {
        setKinderDaten(response.data.kinder);
      }
      if (response.data.fields) {
        setSonstigeFelder(response.data.fields);
      }
      if (response.data.notkontakt) {
        setNotkontaktDaten(response.data.notkontakt);
      }
      if (response.data.lohnDaten) {
        setSteuerDaten(response.data.lohnDaten);
      }
      if (response.data.bearbeitung === "1") {
        setBearbeitung(true);
      } else {
        // Auf true setzen um Kind hinzufügen zu testen
        // setBearbeitung(true);
        setBearbeitung(false);
      }
      setShowKinder(response.data.showKinder);
      setKinderBeantragen(response.data.kinderBeantragen);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const errorCb = () => {
    showErrorMessage(t("Keine Internetverbindung"));
  };

  return (
    <Page>
      <Layout>
        <Grid container spacing={0.5}>
          {bankDaten?.anzeige && (
            <Grid item xs={12}>
              <Accordion>
                <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
                  <Typography fontWeight={650}>{t("Bankdaten")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <MasterDataBank
                    daten={bankDaten}
                    reloadDaten={reloadDaten}
                    setReload={setReload}
                    accessToken={accessToken}
                    client={client}
                    bearbeitung={bankDaten?.bearbeitung}
                  ></MasterDataBank>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
          <Grid item xs={12}>
            <Accordion>
              <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
              <Typography fontWeight={650}>{t("Steuer- und Sozialversicherungsdaten")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ProfileLohnDetails daten={steuerDaten}></ProfileLohnDetails>
              </AccordionDetails>
            </Accordion>
          </Grid>
          {showKinder && (
            <Grid item xs={12}>
              <Accordion>
                <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
                  <Typography fontWeight={650}>{t("Kinder")}</Typography>
                  {/* <EuroIcon color='primary' sx={{ transform: 'none',  marginLeft: 2 }} /> */}
                </AccordionSummary>
                <AccordionDetails>
                  <MasterKinderComponent
                    client={client}
                    kinderBeantragen={kinderBeantragen}
                    showKinder={showKinder}
                    daten={kinderDaten}
                    setReload={setReload}
                    reloadDaten={reloadDaten}
                    user={user}
                    accessToken={accessToken}
                    bearbeitung={bearbeitung}
                  ></MasterKinderComponent>
                  {/* {priv === "false" &&
                  <MasterKinderComponent daten={kinderDaten} setReload={setReload} user={user} accessToken={accessToken} bearbeitung={bearbeitung}></MasterKinderComponent>
                }
                {priv !== "false" &&
                  <Typography>Bitte den Privaten Bereich für dieses Gerät aktivieren</Typography>
                } */}
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
          {adressDaten?.anzeige && (
            <Grid item xs={12}>
              <Accordion>
                <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
                   <Typography fontWeight={650}>{t("Adressdaten")}</Typography>
                  {/* <AccountBoxIcon color='primary' sx={{ transform: 'none',  marginLeft: 2 }} /> */}
                </AccordionSummary>
                <AccordionDetails>
                  <MasterDataAdress
                    daten={adressDaten}
                    reloadDaten={reloadDaten}
                    setReload={setReload}
                    accessToken={accessToken}
                    client={client}
                    bearbeitung={adressDaten?.bearbeitung}
                  ></MasterDataAdress>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
          {notkontaktDaten?.anzeige && (
            <Grid item xs={12}>
              <Accordion>
                <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
                  <Typography fontWeight={650}>{t("Notfallkontakte")}</Typography>
                  {/* <AccountBoxIcon color='primary' sx={{ transform: 'none',  marginLeft: 2 }} /> */}
                </AccordionSummary>
                <AccordionDetails>
                  <MasterNotkontakt
                    daten={notkontaktDaten}
                    setReload={setReload}
                    accessToken={accessToken}
                    reloadDaten={reloadDaten}
                    client={client}
                    bearbeitung={notkontaktDaten?.bearbeitung}
                  ></MasterNotkontakt>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
          {sonstigeFelder.length > 0 && (
            <Grid item xs={12}>
              <Accordion>
                <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
                   <Typography fontWeight={650}>{t("Sonstige Daten")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <MasterSonstige
                    user={user}
                    sonstigeFelder={sonstigeFelder}
                    daten={personalDaten}
                    reloadDaten={reloadDaten}
                    setReload={setReload}
                    reload={datenHolen}
                    accessToken={accessToken}
                    client={client}
                    bearbeitung={bearbeitung}
                  ></MasterSonstige>
                </AccordionDetails>
              </Accordion>
            </Grid>
          )}
          {/* <Grid item xs={12}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDownwardIcon />}
              >
                <Typography>{t("Personalinformation")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Personalinformation user={user} daten={personalDaten} setReload={setReload} accessToken={accessToken} client={client} bearbeitung={bearbeitung}></Personalinformation>
              </AccordionDetails>
            </Accordion>
          </Grid> */}
        </Grid>
      </Layout>
    </Page>
  );
}

export default MasterDataChange;
